import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { KeyboardAwareScrollView } from '../modules';

import { updatePromoCode } from '../actions/user';
import Utils from '../utils/Utils';
import APIClient from '../utils/APIClient';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class UpdatePromoCodeScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
      headerTitle: 'Đổi mã giới thiệu',
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      promoCode: '',
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {user} = this.props;
    const {promoCode} = this.state;
    let errorMessage, textInputRef;
    if (_.isEmpty(promoCode)) {
      errorMessage = 'Vui lòng nhập mã giới thiệu mới';
      textInputRef = 'promoCodeTextInput';
    } else if (promoCode === user.info.promoCode) {
      errorMessage = 'Vui lòng nhập mã giới thiệu khác với mã giới thiệu hiện tại';
      textInputRef = 'promoCodeTextInput';
    }
    if (errorMessage) {
      AlertUtils.alert({
        message: errorMessage,
        actions: [
          {text: 'OK', onPress: () => this._focusTextInput(textInputRef)},
        ],
      });
      if (Platform.OS === 'web') {
        this._focusTextInput(textInputRef);
      }
      return;
    }

    this.setState({
      submitting: true,
    });

    const data = {
      promo_code: promoCode,
    };
    const {response, error} = await APIClient.PUT('/seller', data);
    this._handleNetworkResponse(promoCode, response, error);
  };

  _handleNetworkResponse (promoCode, response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    if (response && response.response) {
      this.props.updatePromoCode(_.toUpper(promoCode));
      const message = 'Cập nhật mã giới thiệu thành công';
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
          [
            {text: 'OK', onPress: () => this.props.navigation.goBack()},
          ],
        );
      }
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Cập nhật mã giới thiệu không thành công, vui lòng thử lại sau');
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
        );
      }
    }
  }

  render () {
    const {user} = this.props;
    const {promoCode, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='never'
          containerContentStyle={styles.contentContainer}
          style={styles.content}>

          <Text
            style={styles.inputTitleText}>
            Mã giới thiệu hiện tại
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='currentPromoCodeTextInput'
              value={_.isEmpty(user.info.promoCode) ? '' : user.info.promoCode}
              placeholder='Mã giới thiệu hiện tại'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              editable={false}
              style={styles.textInput}
              onSubmitEditing={() => this._focusTextInput(
                'promoCodeTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Mã giới thiệu mới
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='promoCodeTextInput'
              value={promoCode}
              placeholder='Mã giới thiệu mới'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='characters'
              returnKeyType='send'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('promoCode', text)}
              onSubmitEditing={() => this._submit()}/>
          </View>

          <TouchableOpacity
            activeOpacity={0.75}
            style={styles.submit}
            onPress={() => this._submit()}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              CẬP NHẬT MÃ GIỚI THIỆU
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating={true}
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>

        </KeyboardAwareScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 12,
    marginBottom: 12,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePromoCode: (promoCode) => dispatch(updatePromoCode(promoCode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  UpdatePromoCodeScreen);



// WEBPACK FOOTER //
// ./src/profile/UpdatePromoCodeScreen.js